import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StateFacade } from './state.facade';

/**
 * @description
 * this service is the base class for store data access. feature services which inherits this service
 * can access stored their own specific data by providing a customized implementation for this method
 */

@Injectable({
  providedIn: 'root'
})
export abstract class StateAccessService<T> {
  /** data access abstraction to be implemented by heirs */
  abstract readonly state$: Observable<T>;

  /** a shortcut to the base store facade */
  protected get stateFacade(): StateFacade {
    return this._facade;
  }

  private _facade: StateFacade;

  constructor() {
    this._facade = inject(StateFacade);
  }
}
